import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Mail = function Mail(props) {
  useDeprecatedComponentWarning({
    component: 'Mail'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M2048 384l-1024 768L0 384q0-53 37.5-90.5T128 256h1792q53 0 90.5 37.5T2048 384zM0 614l1024 768 1024-768v1050q0 53-37.5 90.5T1920 1792H128q-53 0-90.5-37.5T0 1664V614z"
  }));
};

Mail.displayName = 'Mail';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Mail.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Mail;